/**
 * 人工英文文案（仅收录译员表中已填写译文的字段）
 * 未收录字段 t() 回退中文，由小牛页面翻译
 */
export default {
  siteTitle: 'Power Engineering Standards Platform',
  nav: {
    home: 'HOME',
    standardSearch: 'STANDARDS SEARCH',
    csepdi: 'CENTRAL SOUTHERN CHINA ELECTRIC POWER DESIGN INSTITUTE',
    snerdi: 'STATE NUCLEAR ELECTRIC POWER PLANNING DESIGN & RESEARCH INSTITUTE',
    gxedi: 'CHINA ENERGY ENGINEERING GROUP GUANGXI ELECTRIC POWER DESIGN INSTITUTE',
    digitization: 'DIGITAL STANDARDS BENCHMARKING',
    benchmarking: 'CHINA-INTERNATIONAL STANDARDS BENCHMARKING SHOWCASE',
    benchmarkSurvey: 'ENGINEERING BENCHMARKING',
    benchmarkInstall: 'CONSTRUCTION BENCHMARKING',
    standardTranslation: 'ENGLISH PUBLICATIONS OF CHINESE STANDARDS',
    technicalRegulations: 'COUNTRY-SPECIFIC TECHNICAL REGULATIONS',
    languageService: 'STANDARDIZATION LANGUAGE SERVICES',
    informationNavigation: 'INTERNATIONAL INFORMATION NAVIGATION',
    standardList: 'INTERNATIONAL POWER ENGINEERING STANDARDS LIST',
    tipTitle: 'Notice',
    vipTips: 'Friendly Reminder: This content is available exclusively to VIP members. To upgrade to VIP, please contact Customer Service. Service Hotline: 027-87665517 ext. 6003. Email: userservice@sunther.com',
  },
  header: {
    platformName: 'Power Engineering Standards Platform',
    message: 'Messages',
    feedback: 'Request Feedback',
    login: 'Log In',
    register: 'Register',
    hello: 'Hello',
    settings: 'Profile Settings',
    myCollection: 'My Favorites',
    myOrder: 'My Orders',
    orderManage: 'Order Management',
    logout: 'Log out',
  },
  home: {
    viewMore: 'More',
    searchPlaceholder: 'Please enter keywords',
    searchBtn: 'Search',
    searchEmptyTips: 'Please enter search keywords',
    searchSynthesis: 'Comprehensive Search',
    searchComparison: 'Standards Benchmarking',
    searchId: 'Standard No.',
    searchName: 'Standard Title',
    searchContent: 'Clause Content',
    techKeywords: 'Recommended Related Technical Keywords',
    crossKeywords: 'Recommended Cross-Language Keywords',
    designTitle: 'Comparative Study of Chinese Electric Power Design Standards, International Standards, and Foreign Standards',
    designSubheading: 'Comparative Study of Chinese Electric Power Design Standards, International Standards, and Foreign Standards is the first large-scale, specialized multi-volume series completed in conjunction with the "Chinese Power Standards Internationalization Project." The series comprises 27 volumes in four professional categories: electric power engineering survey, thermal power generation engineering, power transmission and transformation engineering, and new energy engineering.',
    designDialogTitle: 'Comparative Study of Chinese Electric Power Design Standards, International Standards, and Foreign Standards series',
    designDialogP1: 'Sponsored by the China Electric Power Planning & Engineering Association, the preparation of the Comparative Study of Chinese Electric Power Design Standards, International Standards, and Foreign Standards series was led by 11 design institutes, with the participation of a total of 14 design institutes. Using Chinese standards as the baseline, the study compares China\'s current national (GB) and industrial (DL) power design standards issued up to 2013 with standards of international organizations and institutions such as IEC, IEEE, ISO, the European Union, and the World Bank, as well as the standards of 11 countries including the United States. The comparisons are organized by standard, discipline, and module. Key provisions concerning safety, environmental protection, main parameters, and technical requirements are evaluated, including the relative level of stringency and reasons for differences, and application guidance is provided.',
    designDialogP2: 'In December 2010, the China Electric Power Planning & Engineering Association proposed the project of Comparative Study of Chinese Electric Power Design Standards, International Standards, and Foreign Standards, and organized an expert review at which the project proposal was approved. In June 2015, the preparation of the 27 volumes comprising 52 booklets was completed. The series is organized into four professional categories: electric power engineering survey, thermal power generation engineering, power transmission and transformation engineering, and new energy engineering. The publication of the Comparative Study of Chinese Electric Power Design Standards, International Standards, and Foreign Standards is of far-reaching significance in advancing the internationalization of Chinese power design standards and removing barriers to technical exchange between China and other countries.',
    constructionTitle: 'Comparative Study of Selected Chinese Power Construction Standards, International Standards, and Foreign Standards',
    constructionSubheading: 'The Research Project on the Application of Technical Standards for Thermal Power/Transmission and Transformation Construction in International Projects studies Chinese and foreign construction technical standards across eight disciplines: civil works, boilers, turbines, electrical systems, I&C, welding, commissioning, and power transmission and transformation.',
    constructionDialogTitle: 'Comparative Study of Chinese Electric Power Design Standards, International Standards, and Foreign Standards series',
    constructionDialogP1: 'The "Research Project on the Application of Technical Standards for Thermal Power/Transmission and Transformation Construction in International Projects" studies Chinese and foreign construction technical standards across eight disciplines: civil works, boilers, turbines, electrical systems, I&C, welding, commissioning, and power transmission and transformation. The work specifically includes research on Chinese and foreign technical standard systems, translation of important Chinese and foreign technical standards, comparison of Chinese and foreign technical standards, case studies on comparative application of Chinese and foreign standards in international projects, development of a workstation for research on the application of international engineering technical standards, and related training activities. The research results will help enterprises quickly understand international standards, especially advanced international technical standards, identify the differences and relationships between Chinese and foreign technical standards, and enhance their international competitiveness. Benchmarking against and adopting advanced standards helps enterprises provide customers with high-quality products and services, strengthen market confidence, expand into international markets, and gain a competitive advantage.',
    publicationTitle: 'English Publications of Chinese Standards',
    tradeTitle: 'Country-specific Technical Regulations',
    groupTitle: 'CEPPEA Standards',
    groupSubheading: 'To promote technological innovation and management standardization of the industry in line with the national policies, CEPPEA began the work in relation to association standards in 2017 (CEPPEA Standards), establishing the related management system, standards framework, and governance structure and progressively developing standards. CEPPEA Standards are market- and innovation-oriented, covering the full EPC process and focusing on new technologies, industries, business forms, and models. Current priorities are filling gaps and strengthening competitiveness of standards.',
    mapTitle: 'World Standards Map',
    announcementTitle: 'Platform Announcements',
    renewalTitle: 'Recently Updated Standards',
    currentStatus: 'Current',
    publishedCeppea: 'Published CEPPEA Standards',
    solicitCeppea: 'CEPPEA Standards for Public Comment',
    publishedTips: 'To better serve members, CEPPEA now provides full-text public access to its published association standards.',
    solicitTips1: 'After a draft CEPPEA Standard for public consultation has been completed, the Association solicits comments by letter from stakeholders whose interests are affected by the content of the standard.',
    solicitTips2: 'The public consultation period is generally no less than 30 days. Organizations or individuals consulted should respond by the specified deadline. Supporting grounds or reasons should be provided for all comments. Failure to respond by the deadline will be deemed to indicate no objection.',
    mapCountry: 'Country',
    mapIso: 'International Organization for Standardization',
    mapCollectLabel: 'Information Collection Completion:',
    mapHigh: 'High',
    mapMedium: 'Medium',
    mapLegendMedium: 'Information Collection Completion – Medium',
    mapLegendHigh: 'Information Collection Completion – High',
  },
  common: {
    collapse: 'Collapse',
    expand: 'Expand',
    tip: 'Notice',
    confirm: 'Confirm',
    cancel: 'Cancel',
    loginSuccess: 'Login Successful',
    logoutSuccess: 'Logout Successful',
    notLoggedIn: 'You are not logged in. Please log in.',
    rolesSyncFail: 'Permission synchronization failed!',
    copySuccess: 'Copied successfully',
    networkError: 'Network error',
    noPermission: 'No permission. Please contact the administrator at userservice@sunther.com',
    noPermissionExclaim: 'No permission. Please contact the administrator at userservice@sunther.com!',
    sessionExpired: 'Your login session has expired. Please log in again!',
  },
  footer: {
    intro: 'Founded in 1995, based on proprietary cross-language data mining and filtering technology, SUNTHER is an information technology company providing industry data benchmarking support and related data service for standardization organizations, engineering companies, manufacturing companies, trading companies, technical research companies.',
    officialSite: 'Official Website',
    hotline: 'Service Hotline',
    serviceEmail: 'Customer Service Email',
    followUs: 'Follow Us',
    copyright: 'Copyright © 1995–2026 – Power Engineering Standards Platform Lu ICP No. 11005380-1 All Rights Reserved © SUNTHER Industry Data Benchmarking Co., Ltd.',
  },
  standard: {
    footerCopyright: 'Copyright © 1995–2026 – Power Engineering Standards Platform Lu ICP No. 11005380-1 All Rights Reserved © SUNTHER Industry Data Benchmarking Co., Ltd.',
    statusCheck: 'Standard Status Check',
    reset: 'Reset',
    startStopNotice: 'Standard Implementation/Revocation Notification',
    startStopTitle: 'Standard Implementation/Revocation Notification',
    menuKeywordPlaceholder: 'Please enter search keywords',
    menuSearch: 'Search',
    menuPrev: 'Previous',
    menuNext: 'Next',
    blurTitle: 'Fuzzy Search',
    blurEmptyMatch: 'Please enter keywords to match',
    blurCollapseFilter: 'Collapse Filters',
    blurExpandFilter: 'Expand Filters',
    blurKeywordLabel: 'Search Keywords',
    statusTitle: 'Standard Status Check',
    statusDesc: 'The "Standard Status Check" function can check the status details of standards in batches by standard No. and provide both the current status and the latest version of each standard.',
    statusNote: 'Note: Please first download the Excel template below, complete it as instructed, and then upload it.',
    statusDownloadTemplate: 'Download Template',
    statusSubmit: 'Spreadsheet Submission',
    statusDownloadResult: 'Download Results',
    statusFileTypeError: 'Invalid file type',
    statusFileUploaded: 'The file has already been uploaded',
    precisionTitle: 'Exact Search',
    precisionSearch: 'Search',
    precisionReset: 'Reset',
    unlimited: 'No limit',
    noMoreData: 'No more data',
    stdName: 'Standard Title',
    stdNamePlaceholder: 'Enter standard title',
    stdNo: 'Standard No.',
    stdNoPlaceholder: 'Enter standard No.',
    language: 'Language',
    languagePlaceholder: 'Select language',
    yearNumber: 'Year Designation',
    yearPlaceholder: 'Select year designation',
    to: 'To',
    ics: 'ICS Classification',
    icsPlaceholder: 'Enter ICS classification',
    viewIcs: 'View ICS classification',
    icsDialogTitle: 'ICS Classification',
    ccs: 'CCS Classification',
    ccsPlaceholder: 'Please enter CCS number',
    viewCcs: 'View CCS classification',
    ccsDialogTitle: 'CCS Classification',
    resource: 'Standard Source',
    resourcePlaceholder: 'Select standard source',
    status: 'Standard Status',
    statusPlaceholder: 'Select standard status',
    materialDate: 'Implementation Date',
    releaseDate: 'Release Date',
    draftUnit: 'Drafting Organization',
    draftUnitPlaceholder: 'Enter drafting organization',
    drafter: 'Drafter',
    drafterPlaceholder: 'Enter drafter',
    batchTip: 'Download after applying precise multi-criteria filters!',
    bulkExport: 'Batch Export',
    confirm: 'Confirm',
    cancel: 'Cancel',
    exportDisclaimer: 'Text, images, and other materials reproduced on this website are provided solely to disseminate useful information to the public and not for profit. Reproduction does not imply endorsement of the views expressed or verification of the authenticity of the content. This website makes no warranty of any kind as to the scientific accuracy, rigor, or other qualities of such materials. Other media organizations, websites, or individuals that download and use materials from this website are solely responsible for any copyright or other legal liabilities arising from such use.',
    selectFileFirst: 'Please select a file!',
    fileTitleModal: 'Export File Title',
    fileTitleLabel: 'File Title',
    fileTitlePlaceholder: 'Enter file title',
    fileTitleRequired: 'Enter file title',
    downloading: 'Downloading. Please wait!',
    orientation: 'Position in Standards System',
    orientationTip: 'Click this icon to directly locate the standard and view its position in the standards system tree on the left.',
    orientationFail: 'Failed to locate in standards system!',
    colIndex: 'No.',
    colStdNo: 'Standard No.',
    colStdName: 'Standard Title',
    colLanguage: 'Language',
    colStatus: 'Status',
    colAction: 'Action',
    uncollectSuccess: 'Deleted successful!',
    collectSuccess: 'Added to favorites successful!',
    uncollectFail: 'Deletion failed!',
    collectFail: 'Failed to add to favorites!',
    downloadConfirm: 'Download text?',
  },
  standardDetail: {
    stdNameZh: 'Technical Standard Title (Chinese):',
    stdNameEn: 'Technical Standard Title (English):',
    stdNameOriginal: 'Technical Standard Title (Source):',
    stdNameTrans: 'Technical Standard Title (Translation):',
    basicInfo: 'Basic Information',
    resourceOrg: 'Standard Source/Issuing Organization:',
    language: 'Language:',
    ics: 'ICS Classification Number:',
    hasTranslation: 'Translation Available:',
    ccs: 'CCS Classification Number:',
    industry: 'Industry:',
    yearNumber: 'Year Designation:',
    specialty: 'Discipline:',
    materialDate: 'Effective Date:',
    enforce: 'Mandatory Standard:',
    category: 'Standard Category:',
    technicalCommittees: 'Administration Organization',
    executionUnit: 'Implementing Organization',
    competentDepartment: 'Competent Authority',
    draftUnit: 'Drafting Organization',
    drafter: 'Drafter',
    useScope: 'Scope of Application',
    replaceStd: 'Replace the Following Standards',
    stdUse: 'Adopted by the Following Standards',
    replaceBy: 'Replaced by the Following Standards',
    project: 'Associated Engineering Projects',
    exportDetail: 'Export Details',
    getText: 'Get Text',
    viewTrans: 'View Translation',
    viewOriginal: 'View Source',
    downloadOriginal: 'Download Source',
    downloadText: 'Download Text',
    none: 'None',
    loading: 'Loading...',
    username: 'Username:',
    exportTime: 'Export Time:',
    dataFormatError: 'Invalid data format. Failed to retrieve details!',
    fileLoadFail: 'Failed to load file!',
    createFail: 'Failed to create data. Please refresh and try again!',
  },
  digitization: {
    surveyDesign: 'Engineering',
    installation: 'Construction',
    categoryFilterPlaceholder: 'Select a category to filter',
    keywordPlaceholder: 'Enter keywords from the benchmark point name to search',
    colIndex: 'No.',
    colCategory: 'Category',
    colName: 'Benchmark Point Name',
    colAction: 'Action',
    viewCompare: 'View Benchmarking Results',
  },
  standardComparison: {
    searchPlaceholder: 'Enter keywords for standards benchmarking to search',
    compareList: 'Benchmarking List',
    pointList: 'Benchmark Point List',
    compareResult: 'Benchmarking Results',
    pointLabel: 'Benchmark Point:',
    domesticStd: 'Chinese Standard:',
    foreignStd: 'Foreign Standard:',
    checkTip: 'Select a benchmark point on the left to view benchmarking results',
    trans: 'Translation',
    original: 'Source',
    onlyTransTip: 'Only the translation is provided here. If you need the source text for reference, please submit a request.',
    onlyOriginalTip: 'Only the source text is provided here. If you need a translation for reference, please submit a request.',
  },
  benchmarking: {
    fullTextSearch: 'Full Text Search',
    titleSearch: 'Title Search',
    advancedSearch: 'Advanced Search',
    specialty: 'Discipline Volume',
    specialtyPlaceholder: 'Please select a discipline volume',
    deepSpecialty: 'Subdiscipline Volume',
    deepSpecialtyPlaceholder: 'Please select a subdiscipline volume',
    contentType: 'Content Category',
    contentTypePlaceholder: 'Please select a content category',
    countryType: 'Country/Organization',
    countryTypePlaceholder: 'Please select a country classification',
    overview: 'Overview',
    compareStandards: 'Chinese and Foreign Standards Included in the Benchmarking',
    mainCompare: 'Main Benchmarking Content',
    compareNote: 'Benchmarking Notes',
    projectSummary: 'Project Summary',
    chinaPrefix: 'China',
    noData: 'No data available',
    collapseMore: 'Collapse More',
    networkError: 'Device network error',
  },
  benchmarkingDetail: {
    indexCatalog: 'Index/Table of Contents',
    exportPage: 'Export Page',
    keywordPlaceholder: 'Please enter keywords',
    searchResult: 'Search Results',
    pageMatchSuffix: 'match(es) on this page',
    exportPreview: 'Export Preview',
    articleLoading: 'The article has not finished loading. Please wait for a while!',
    exportComplete: 'Export completed',
    maxKeywords: 'A maximum of three keywords is allowed!',
    menuIdEmpty: 'Menu ID is empty!',
  },
  standardTranslation: {
    subtitle: 'Promotion of English publications of Chinese power industry codes and standards authorized by CEPPEA',
    standardElement: 'Standardization Elements',
    relatedStandard: 'Related Standards',
  },
  technicalRegulations: {
    lawsSearchPlaceholder: 'Laws and regulations search',
    updatedLaws: 'Updated Laws and Regulations',
    recentlyUpdated: 'Recent Updates',
    allCountries: 'All countries',
    bilingualReading: 'Bilingual Reading',
    translationReading: 'Translation Reading',
    originalReading: 'Source Reading',
  },
  industryInformationBase: {
    downloadReport: 'Download Report',
    downloadOriginal: 'Download Source',
    downloadTrans: 'Download Translation',
    original: 'Source Text',
    translation: 'Translation',
    currentPage: 'Current Page',
    nationalInfoBase: 'National Industry Information Database',
    lawsRegulations: 'Country-Specific Laws and Regulations',
    standardTrade: 'Application of Chinese and Foreign Standards',
    transfer: 'International Technology Transfer',
    userInfoBase: 'User Information Database',
    idNotExist: 'ID does not exist!',
    keyNotExist: 'Critical key does not exist!',
    keywordSearchPlaceholder: 'Enter keywords to search within the file',
  },
  languageService: {
    submitOrder: 'Submit Order',
    orderConfirmTitle: 'Please confirm the machine translation order information',
    knowledgeTitle: 'Translation Notes',
    knowledgeMachineTip: 'To ensure translation quality, we recommend that documents submitted for translation meet the following requirements:',
    knowledgeHumanTip: 'Human translation services are available at three quality levels: professional, publication, and SCI paper translation (electrical engineering). Prices vary by service level. Our staff will contact you to discuss the specific pricing of human translation.',
    knowledgeLangMachine: 'Language pair: Chinese <-> English',
    knowledgeSpecialty: 'Fields: science, technology, engineering, mathematics, and industrial sectors',
    knowledgeFormat: 'Document formats: doc, docx, xls, xlsx, ppt, pptx, and legible reproducible pdf documents',
    knowledgeHumanTypes: 'The following document types/languages are currently supported by our human translation service:',
    knowledgeLangHuman: 'Languages: English, French, Japanese, Korean, German, Russian, Spanish, Portuguese, Indonesian, and Persian',
    wechatPay: 'WeChat Pay',
    alipayPay: 'Alipay',
    transType: 'Means of Translation',
    transTypeRequired: 'Please select the means of translation',
    instructionsHuman: 'Note: machine translation plus accurate proofreading by industry experts; applicable to the translation of technical and commercial documents; free DTP, ensuring consistency between the source texts and translation texts.',
    instructionsMachine: 'Note: STEM machine translation is a good choice for customers who are in urgent need of reference translations of large volume of documents.',
    languageDirection: 'Language Pair',
    uploadFile: 'Upload Documents',
    fileUploadFail: 'Document upload failed',
    fileDeleteSuccess: 'Document deleted successfully',
    uploadDragTip: 'Click or drag documents here to upload',
    uploadSupportTip: 'Documents in doc, docx, xls, xlsx, ppt, pptx, legible reproducible pdf formats can be uploaded.',
    contactName: 'Contact Information',
    contactNamePlaceholder: 'Please enter your name',
    contactNameRequired: 'Please enter your name',
    mobilePhone: 'Tel.',
    mobilePhonePlaceholder: 'Please enter your telephone number',
    mobilePhoneRequired: 'Please enter your telephone number',
    remark: 'Remarks',
    remarkPlaceholder: 'Please enter the requirements',
    deliveryTime: 'Delivery Time',
    deliveryTimeDesc1: 'The delivery time of translations depends on the volume of documents. In general, the translations of an order placed during working hours are delivered on the day or the next day;',
    deliveryTimeDesc2: 'Urgent service is available by calling 0531-88897205 or 18627076118 (Manager Xu).',
    uploadFileRequired: 'Please upload document(s)',
    selectPayMethod: 'Select payment method:',
    confirmAndPay: 'Confirm and Pay',
    confirmTranslate: 'Confirm Translation',
    cancel: 'Cancel',
    textNum: 'Translation Character Count',
    textNumPlaceholder: 'Please enter translation character count',
    priceMultipleMt: 'Language rate (RMB/1,000 Chinese characters)',
    priceMultipleMtPlaceholder: 'Enter language rate (RMB/1,000 Chinese characters)',
    freeWordsUsed: 'Use Free Character Allowance',
    freeWordsUsedPlaceholder: 'Enter free character allowance to use',
    wordCount: 'Billable Character Count',
    wordCountPlaceholder: 'Please enter the billable character count',
    originalPrice: 'Total Order Price (RMB)',
    originalPricePlaceholder: 'Please enter the total order price',
    discountedPrice: 'Discount',
    discountedPricePlaceholder: 'Please enter the discount',
    exceededWordCount: 'Amount Paid (RMB)',
    exceededWordCountPlaceholder: 'Please enter the amount paid (RMB)',
  },
  informationNavigation: {
    dataSourceNav: 'Data Source Navigation',
    pleaseLogin: 'Please log in!',
  },
  standardList: {
    headerDesc: 'The International Power Engineering Standards List is consolidated by SUNTHER based on the project and standards information collected by provincial-level and higher member institutes, under the leadership of the China Electric Power Planning & Engineering Association (CEPPEA). The List covers technical standards used in 219 projects implemented from 2016 to the present, which are located across 184 provinces/regions in 61 countries and regions and cover thermal power generation, hydropower generation, new energy generation, power transmission and transformation, energy storage, integrated energy, consulting, and other fields.',
    projectTitle: 'International Power Engineering Projects List',
    exportList: 'Export List',
    selectExportData: 'Please select the data to export',
    exportFileNameProject: 'International Power Engineering Standards List_Project',
    colIndex: 'No.',
    colProjectName: 'Project Name',
    colProjectType: 'Project Category',
    colProjectDesc: 'Project Description',
    colProjectRegion: 'Project Region',
    colStdCount: 'Number of Standards',
    viewList: 'View List',
    projectTypePlaceholder: 'Please select the project category',
    region: 'Region',
    regionPlaceholder: 'Please select the region',
    all: 'All',
    exportFileNameStd: 'International Power Engineering Standards List_Standards',
    invalidData: 'Invalid data!',
    powerListTitle: 'International Power Engineering Standards List',
    viewDetail: 'View Details',
  },
  message: {
    title: 'Message Center',
    systemMessage: 'System Messages',
    notice: 'Announcements',
  },
  feedback: {
    title: 'Request Feedback',
    putForward: 'Submit Request',
    selectType: 'Please select a request type!',
    welcomeUser: 'Dear User:',
    welcomeBody: 'Hello! To further improve the PES platform and better meet engineers\' practical work needs in terms of functionality, data coverage, and user-friendliness, we have created a "Request Feedback Center" that allows users to submit their needs conveniently and efficiently. Please select the appropriate request type using the links on the left, complete and submit the request form, and we will contact you promptly with updates on the progress of your request.',
    menuTechText: 'Technical Standard Text Request',
    menuOptimize: 'Function Optimization/New Feature Request',
    menuSystem: 'Technical Standards System Request',
    menuComparison: 'Chinese-Foreign Technical Standards Benchmarking Request',
    menuTranslation: 'Technical Standard Translation Request',
    submitNeed: 'Submit Request',
    submitSuccess: 'Your request has been submitted',
    submitFail: 'Submission failed',
    techTextTips: 'If there are standards you use frequently in your daily work, please submit your request through this module!',
    techTextJoin: 'If you know the number or title of the standard you are interested in, please complete the form below:',
    specialty: 'Discipline',
    stdResource: 'Standard Code/Standard Source',
    translationChargeNote: '(Note: Obtaining the translation of a standard is a <span class="hl">paid service</span>. After you submit the relevant request, a quotation will be sent to your email, or a representative will contact you to discuss the quotation.)',
    optimizeTips: 'If you find that any functions of the PES website need improvement, or if you would like new functions to be added, please submit your request through this module!',
    needPlaceholder: 'Please enter your request',
    needRequired: 'Please enter your request',
    systemTips: 'If there is a standards system you use frequently in your daily work, please submit your request through this module!',
    systemJoin1: '1. Please enter the standards system you would like PES to add:',
    sysShortName: 'Standards System Abbreviation',
    sysFullName: 'Full Name of Standards System',
    sysUrl: 'Standards System Link',
    systemJoin2: '2. If you do not know the exact name or link of the standards system, please describe your request in detail below.',
    needDescPlaceholder: 'Please enter your detailed request',
    kbClauseName: 'Benchmark Point Name',
    kbStdNo: 'Chinese Standard No.',
    kbStdName: 'Chinese Standard Title',
    kbStdNoEn: 'English Standard No.',
    kbStdNameEn: 'English Standard Title',
    projectType: 'Project Type',
    projectTypePlaceholder: 'Please select the project type',
    projectStage: 'Project Stage',
    projectStagePlaceholder: 'Please select the project stage',
    projectCategory: 'Project Category',
    projectCategoryPlaceholder: 'Please select the project category',
    projectScale: 'Project Scale',
    projectScalePlaceholder: 'Please select the project scale',
    scopeNum: 'Number of units/sets',
    scopeSize: 'Unit capacity',
    scopeLevel: 'Voltage level',
    scopeLength: 'Line length',
    scopeOther: 'Others',
    perfectInfoTitle: 'Complete personal information',
    perfectInfoTips: 'The following information is very important, please complete it carefully so that we can contact you promptly!',
    perfectInfoBtn: 'Complete Information',
    confirm: 'Confirm',
    userName: 'Name',
    userNamePlaceholder: 'Please enter your name',
    userNameRequired: 'Please enter your name',
    email: 'Email',
    emailPlaceholder: 'Please enter your email',
    emailRequired: 'Please enter your email',
    mobilePhone: 'Mobile number',
    mobilePhonePlaceholder: 'Mobile number format: 13311111111, International number: 14139621234',
    telephone: 'Landline number',
    telephonePlaceholder: 'Landline number format: 010-11111111, 0101-1111111, 010-11111111-1111',
    company: 'Organization',
    companyPlaceholder: 'Please enter your organization',
  },
  individualCenter: {
    vipExpirePrefix: 'VIP Valid Until:',
    mtFreeQuota: 'Free Machine Translation Allowance:',
    enterpriseVip: 'Enterprise VIP',
    enterpriseVipExpired: 'Expired enterprise VIP',
    notLoggedIn: 'User is not logged in!',
    networkError: 'Device network error',
    networkErrorShort: 'Network error',
    changePassword: 'Password Change',
    wantEdit: 'Edit',
    cancelEdit: 'Cancel',
    confirmUpdate: 'Confirm',
    profileUpdateSuccess: 'Profile updated successfully!',
    mobilePlaceholder: 'Please enter mobile number',
    mobileRequired: 'Please enter mobile number',
    telephonePlaceholder: 'Please enter landline number',
    confirmBtn: 'Confirm',
    oldPassword: 'Current Password',
    oldPasswordPlaceholder: 'Please enter your current password',
    oldPasswordRequired: 'Please enter your current password',
    newPassword: 'New Password',
    newPasswordPlaceholder: 'Please enter your new password',
    newPasswordRequired: 'Please enter your new password',
    passwordLength: 'The length must be 8 to 16 characters',
    confirmPassword: 'Password Confirmation',
    confirmPasswordPlaceholder: 'Please re-enter your password for confirmation',
    confirmPasswordRequired: 'Please re-enter your password for confirmation',
    passwordMismatch: 'The two passwords do not match',
    passwordUpdateSuccess: 'Password changed successfully. Please log in again.',
    passwordUpdateFail: 'Password change failed',
    collectTime: 'Collection Time',
    warmTip: 'Friendly Reminder',
    deleteCollectConfirm: 'Are you sure you want to remove this item from favorites?',
    cancelCollectSuccess: 'Removed from favorites successfully!',
    cancelCollectFail: 'Failed to remove from favorites!',
    orderTipsTitle: 'Friendly Reminder:',
    orderTip1: '1. The payment status displayed on this page may be delayed.',
    orderTip2: '2. If a translation order fails, please contact Customer Service at 0531-88897205 or 18627076118 (Manager Xu).',
    machineOrder: 'Machine Translation Orders',
    humanOrder: 'Human Translation Orders',
    searchOrderPlaceholder: 'Please enter the document name or the order number to search',
    orderStatePlaceholder: 'Please select the order status',
    fileName: 'Document Name',
    amount: 'Amount',
    orderState: 'Order Status',
    orderTimePrefix: 'Order Time:',
    orderNoPrefix: 'Order No.:',
    viewOrder: 'View Order',
    downloadTrans: 'Download Translation',
    downloadOriginal: 'Download Source',
    payNow: 'Pay Now',
    cancelOrder: 'Cancel Order',
    contactService: 'Contact Customer Service',
    serviceNotified: 'Customer Service has been notified and will process the request within 24 hours on business days. Please keep the contact number associated with the order available!',
    charCountTipMachine: 'Character count rules for source texts: each Chinese character counts as two characters; English letters, punctuation marks, spaces, and other characters each count as one character.',
    charCountTipHuman: 'For both English-to-Chinese and Chinese-to-English translation, billing is based on the Chinese character count. For Word documents, the character count is based on the "Characters (no spaces)" field in Word\'s word count statistics. For PPT and Excel documents, copy the entire contents into Word and calculate the character count using the method described above.',
    statusPendingPay: 'Pending payment',
    statusOrdered: 'Placed',
    statusTranslating: 'Translating',
    statusPendingPickup: 'Target files ready',
    statusPickedUp: 'Completed',
    statusCancelled: 'Cancelled',
    statusFailed: 'Translation failed',
    unit: 'Organization',
    user: 'User',
    orderInfo: 'Order Information',
    save: 'Save',
    close: 'Close',
    orderId: 'Order No.',
    orderIdPlaceholder: 'Please enter the order No.',
    machineTrans: 'Machine Translation',
    languageDirectionRequired: 'Please select the language pair',
    languageDirectionPlaceholder: 'Please enter the language pair',
    username: 'Username',
    usernamePlaceholder: 'Please enter the username',
    unitName: 'Organization name',
    unitNamePlaceholder: 'Please enter the organization name',
    totalWordCount: 'Total Character Count',
    totalWordCountPlaceholder: 'Please enter the total character count',
    originalPrice: 'Total Order Price',
    originalPricePlaceholder: 'Please enter the total order price',
    amountDue: 'Amount Paid',
    amountDuePlaceholder: 'Please enter the amount paid',
    sourceFile: 'Source Text',
    transFile: 'Translation',
    uploadOriginal: 'Upload Source',
    uploadTrans: 'Upload Translation',
    none: 'None',
    discountedPriceYuan: 'Discount (RMB)',
    discountedPriceYuanPlaceholder: 'Please enter the discount (RMB)',
  },
  orderDetail: {
    title: 'Order Details',
    orderInfo: 'Order Information',
    fileInfo: 'Document Information',
    contactInfo: 'Contact Information',
    paymentInfo: 'Payment Information',
    fold: 'Discount',
    payMethod: 'Payment Method',
    unpaid: 'Unpaid',
    free: 'Free',
    tradeTime: 'Transaction Time',
    tradeNo: 'Transaction No.',
    orderNoPrefix: 'Order No.:',
    statusPrefix: 'Status:',
    downloadTip: 'Dear user, your document has been translated. Please click the document below to download the translation.',
    downloadTransFile: 'Download Translation',
    fileCount: 'Number of Documents',
    transChars: 'Translation Character Count',
    createTime: 'Creation Time',
    languageSpecialty: 'Language/Discipline',
    noData: 'No data available',
    sourceFileColon: 'Source Text:',
  },
  login: {
    intro: 'The PES platform uses cross-language and cross-discipline data association and filtering technologies and is built around the professional logic of advanced international engineering project management. By establishing cooperative relationships with global data sources, it precisely identifies and obtains technical standards, best practices for international power engineering, and other professional technical information. The platform organizes and interrelates these data, manages them through real-time dynamic updates, and objectively presents multidimensional relationships among technical, commercial, and management information throughout all stages of international power engineering project management.',
    title: 'Log In',
    account: 'Account',
    usernamePlaceholder: 'Enter Username',
    usernameRequired: 'Please enter the username',
    password: 'Password',
    passwordPlaceholder: 'Enter password',
    passwordRequired: 'Please enter password',
    captcha: 'Verification Code',
    captchaRequired: 'Please enter the verification code',
    captchaPlaceholder: 'Click the verification code image to refresh it',
    forgetPassword: 'Forgot password?',
    registerNow: 'Register Now',
    registerTitle: 'Register',
    hasAccount: 'Already have an account?',
    loginDirect: 'Log in directly',
    accountPlaceholder: 'Enter your account',
    accountRequired: 'Please enter your account',
    email: 'Email',
    emailPlaceholder: 'Enter your email',
    emailRequired: 'Please enter your email',
    phone: 'Mobile Number',
    phonePlaceholder: 'Enter your mobile number',
    phoneRequired: 'Please enter your mobile number',
    confirmPasswordPlaceholder: 'Re-enter your password for confirmation',
    emailCode: 'Email verification code',
    codePlaceholder: 'Enter the verification code',
    sendEmailCode: 'Send Verification Code to Email',
    accountRegistered: 'This account is already registered. Please use another one!',
    emailRegistered: 'This email is already registered. Please use another one!',
    phoneRegistered: 'This mobile number is already registered. Please use another one!',
    passwordMismatch: 'The two passwords do not match!',
    usernameAvailable: 'Username is available!',
    emailAvailable: 'Email is available!',
    phoneAvailable: 'Mobile number is available!',
    usernameLength: 'The length must be 2 to 30 characters',
    noSpace: 'Spaces and other special symbols are not allowed',
    emailFormat: 'Please enter a valid email address',
    phoneFormat: 'Please enter a valid mobile number',
    weakPassword: 'Must contain letters, numbers, and special characters; 1-9 characters; and must not contain three consecutive ascending/descending or identical digits.',
  },
  smartQA: {
    newChat: 'New Chat',
    recentChats: 'Recent Chats',
    newSession: 'New Chat',
    renameSession: 'Rename Chat',
    deleteSession: 'Delete Chat',
    noHistory: 'No chat history',
    welcomeTitle: 'Standard AI Q&A Assistant',
    welcomeSubtitle: 'Powered by Chinese and international engineering standards data to answer your questions',
    currentBenchmark: 'Current Benchmark Point:',
    copyContent: 'Copy Content',
    aiGenerating: 'AI is generating…',
    aiThinking: 'AI is thinking…',
    selectedBenchmarkLabel: 'Selected Benchmark Point:',
    cancel: 'Cancel',
    inputPlaceholder: 'Please enter a standards-related question, for example: What is the scope of application of GB 50052?',
    promptConfig: 'Prompt Configuration',
    inputTips: 'AI-generated content is for reference only. Please refer to the official standard text.',
    refsPanel: 'Source Reference',
    relevance: 'Relevance',
    closePromptConfig: 'Close Prompt Configuration',
    systemPromptLabel: 'System Prompt',
    userPromptTemplateLabel: 'User Message Format',
    varHistory: 'Recent Chats',
    varContext: 'Retrieved Context',
    varQuestion: 'User Question',
    resetDefault: 'Restore Defaults',
    save: 'Save',
    renamePlaceholder: 'Please enter a chat title',
    defaultSystemPrompt: 'You are an AI Q&A assistant for power engineering standards. Please answer user questions in English.\nResponse Requirements:\n1. Answer only on the basis of the provided knowledge base materials. Do not fabricate standard numbers, clause numbers, or technical requirements.\n2. When citing materials, place the citation tag immediately after the corresponding conclusion, e.g., [Reference 1]. The tag must match the numbering of the [Reference N] provided; retain the standard No. and clause No.\n3. When answering a question corresponding to a specific technical benchmark point, summarize Chinese and foreign standards separately and cover all distinct standard clauses provided; do not select only certain standards or clauses.\n4. If the provided materials are insufficient to answer the question, state this clearly and list the most relevant standard clauses for the user to consult.\n5. Use concise, structured English in the response; short paragraphs and lists may be used.',
    serviceUnavailable: 'The Q&A service is temporarily unavailable.',
    suggest1: 'How can I quickly find the Chinese-English comparison for a specific standard clause?',
    suggest2: 'How should I interpret the digital standards benchmarking results?',
    suggest3: 'Please recommend standards related to power engineering survey and design.',
    suggest4: 'What are the main differences between GB 50052 and IEC 60364?',
    suggestBenchmark1Prefix: 'Please introduce the main standards associated with benchmark point「',
    suggestBenchmark1Suffix: '」.',
    suggestBenchmark2: 'What are the differences between Chinese and foreign standard requirements in relation to this benchmark point?',
    suggestBenchmark3Prefix: 'Please list the key technical requirements in relation to…',
    connectFailed: 'Unable to connect to the Q&A service. Please confirm that the backend is running.',
    loadSessionFailed: 'Failed to load chat.',
    titleEmpty: 'Chat title cannot be empty.',
    titleUpdated: 'Chat title updated.',
    renameFailed: 'Failed to rename chat.',
    deleteWhileStreaming: 'A response is being generated. Please wait before deleting the chat.',
    deleteConfirmPrefix: 'Are you sure you want to delete 「',
    deleteConfirmSuffix: '」? All Q&A records for this chat will also be deleted.',
    deleteOk: 'Delete',
    deleted: 'Chat deleted.',
    deleteFailed: 'Failed to delete chat.',
    createFailed: 'Failed to create new chat.',
    selectedBenchmarkSuccessPrefix: 'Selected benchmark point:',
    selectBenchmarkFirst: 'Please select a benchmark point first.',
    appliedBenchmarkPrefix: 'Applied benchmark point:',
    copied: 'Copied to clipboard.',
    copyFailed: 'Copy failed. Please select and copy the content manually.',
    systemPromptEmpty: 'System prompt cannot be empty.',
    promptSaved: 'Prompt configuration saved.',
    requestFailedPrefix: 'Request failed:',
    serviceUnavailableRetry: 'Q&A service is temporarily unavailable. Please try again later.',
    noAnswer: 'No response received',
    viewCitation: 'View source reference',
    entryTitle: 'Standard AI Q&A',
    entryDesc: 'Enter a standard-related question, and AI will quickly provide an answer based on platform data.',
    entryBtn: 'Ask Now',
    entryFab: 'AI Q&A',
  },
};
